import React from "react";
import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, OutlinedInput, SelectChangeEvent } from "@mui/material";
import { StaffMember } from "../types/productTypes";

interface Props {
  staffMembers: StaffMember[];
  value: string[];
  onChange: (val: string[]) => void;
}

const StaffSelect: React.FC<Props> = ({ staffMembers, value, onChange }) => {
  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const selectedValue = event.target.value;
    const newValue = typeof selectedValue === "string" ? selectedValue.split(",") : selectedValue;
    onChange(newValue);
  };

  return (
    <FormControl fullWidth variant="outlined" sx={{ mt: 0 }}>
      {" "}
      {/* Remove default margin */}
      <InputLabel id="staff-select-label">Assign Staff Members</InputLabel>
      <Select
        labelId="staff-select-label"
        id="staffList"
        multiple
        value={value}
        onChange={handleChange}
        input={<OutlinedInput label="Assign Staff Members" />}
        renderValue={(selected) => selected.join(", ")}
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 1, 
              maxHeight: 48 * 6, 
            },
          },
        }}
      >
        {staffMembers.map((staff) => (
          <MenuItem key={staff.staff_name} value={staff.staff_name}>
            <Checkbox checked={value.indexOf(staff.staff_name) > -1} />
            <ListItemText primary={staff.staff_name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StaffSelect;
